module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fieldtable"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fields,
      "empty-text": "No Fields Found"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "field_name",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Type",
      "prop": "type_id",
      "formatter": _vm.humanizeType,
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Light Type",
      "prop": "light_type",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Restrike Time",
      "prop": "min_off_time",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Light Status",
      "prop": "light_status",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.light_status === 1) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v(_vm._s(_vm.getSceneName(scope.row.id)))])], 1) : _c('div', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Off")])], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.userIsSuperAdmin) ? _c('el-table-column', {
    attrs: {
      "label": "Operations",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('operations', {
          attrs: {
            "id": props.row.id,
            "showLights": true
          },
          on: {
            "view": _vm.viewScenes,
            "lights": _vm.viewLights,
            "edit": function($event) {
              _vm.editField(props.row)
            },
            "delete": _vm.deleteField
          }
        })]
      }
    }])
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d26d5750","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Fields/FieldTable.vue
// module id = 1012
// module chunks = 9